/**
 * 価格と購入(クロージング)セクションの補助スクリプト
 *
 * 1. クロージング側でバリエーションを選んだとき、上部 main-product のギャラリーと
 *    クロージング内のサムネイルを選択バリエーションの画像に同期する
 * 2. クロージングが画面に入っている間は固定フッター(sticky-product-footer)を隠し、
 *    本物のカートボタンと二重にならないようにする
 *
 * 依存: pubsub.js(subscribe / PUB_SUB_EVENTS)、media-gallery.js(setActiveMedia)
 */
(() => {
  const init = () => {
    const offer = document.querySelector('product-info[id^="ProductClosingOffer-"]');
    if (!offer) return;

    const offerSectionId = offer.dataset.section;

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (!data || data.sectionId !== offerSectionId || !data.variant) return;

        const variant = data.variant;
        const mediaId = variant.featured_media && variant.featured_media.id;
        const main = document.querySelector('product-info[id^="MainProduct-"]');
        const gallery = main ? main.querySelector('media-gallery') : null;

        if (mediaId && gallery && typeof gallery.setActiveMedia === 'function') {
          gallery.setActiveMedia(`${main.dataset.section}-${mediaId}`, false);
        }

        const summaryImage = document.getElementById(`ClosingOfferImage-${offerSectionId}`);
        const src = variant.featured_image && variant.featured_image.src;
        if (summaryImage && src) {
          summaryImage.removeAttribute('srcset');
          summaryImage.src = `${src}${src.includes('?') ? '&' : '?'}width=900`;
        }
      });
    }

    const footer = document.getElementById('StickyProductFooter');
    if (footer && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => footer.classList.toggle('is-suppressed', entry.isIntersecting));
        },
        { threshold: 0.15 }
      );
      observer.observe(offer);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
